var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    class: _vm._f("twMerge")(['w-5 h-5 text-gray-500', _vm.className]),
    attrs: {
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.4516 0.621206L11.1745 1.97018L14.1146 5.07562L15.391 3.72665C15.584 3.52276 15.7372 3.2807 15.8417 3.01428C15.9462 2.74786 16 2.4623 16 2.17393C16 1.88555 15.9462 1.6 15.8417 1.33358C15.7372 1.06716 15.584 0.825093 15.391 0.621206C14.9948 0.222442 14.4685 0 13.9213 0C13.374 0 12.8478 0.222442 12.4516 0.621206Z",
      "fill": _vm.color
    }
  }), _c('path', {
    attrs: {
      "d": "M12.9389 6.31744L9.99872 3.212L6.06991 7.35815C5.95367 7.4807 5.87439 7.63686 5.84208 7.80693L5.40471 10.136C5.37781 10.2778 5.38448 10.4245 5.42413 10.5629C5.46379 10.7014 5.53521 10.8273 5.63204 10.9296C5.72888 11.0319 5.84812 11.1073 5.9792 11.1492C6.11027 11.1911 6.24911 11.1981 6.38338 11.1697L8.5885 10.7042C8.74923 10.6699 8.89677 10.5862 9.01257 10.4636L12.9389 6.31744Z",
      "fill": _vm.color
    }
  }), _c('path', {
    attrs: {
      "d": "M6.06991 7.35815C5.95367 7.4807 5.87439 7.63686 5.84208 7.80693L5.40471 10.136C5.37781 10.2778 5.38448 10.4245 5.42413 10.5629C5.46379 10.7014 5.53521 10.8273 5.63204 10.9296C5.72888 11.0319 5.84812 11.1073 5.9792 11.1492C6.11027 11.1911 6.24911 11.1981 6.38338 11.1697L8.5885 10.7042C8.74923 10.6699 8.89677 10.5862 9.01257 10.4636L12.9389 6.31744L9.99872 3.212L6.06991 7.35815Z",
      "fill": _vm.color
    }
  }), _c('path', {
    attrs: {
      "d": "M9.80581 11.4894C9.57348 11.7344 9.27787 11.9015 8.95602 11.9698L6.01586 12.5907C5.74746 12.6473 5.46997 12.6331 5.20802 12.5493C4.94607 12.4655 4.70776 12.3147 4.51422 12.1103C4.32068 11.9058 4.17791 11.6541 4.09856 11.3774C4.01921 11.1008 4.00574 10.8077 4.05935 10.5242L4.64722 7.41876C4.7119 7.07881 4.87012 6.76659 5.10205 6.5212L9.193 2.20028C9.17025 2.1184 9.15849 2.03355 9.15808 1.94822H1.80185C1.3241 1.94869 0.866052 2.14935 0.528235 2.50615C0.190419 2.86296 0.000440318 3.34676 0 3.85136V14.0969C0.000440318 14.6015 0.190419 15.0853 0.528235 15.4421C0.866052 15.7989 1.3241 15.9995 1.80185 16H11.5021C11.9798 15.9995 12.4379 15.7989 12.7757 15.4421C13.1135 15.0853 13.3035 14.6015 13.3039 14.0969V7.79464L9.80581 11.4894Z",
      "fill": _vm.color
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }